console.log("Assistant Config Loaded");

/* ===================================================
   RECOMMENDATION RULES
=================================================== */

const RECOMMENDATION_RULES = {

    home: [
        "home",
        "house",
        "apartment",
        "flat",
        "villa"
    ],

    shop: [
        "shop",
        "store",
        "business",
        "showroom"
    ],

    office: [
        "office",
        "company",
        "workspace"
    ],

    warehouse: [
        "warehouse",
        "godown"
    ],

    factory: [
        "factory",
        "industry"
    ],

    farm: [
        "farm",
        "agriculture"
    ],

    school: [
        "school",
        "college",
        "classroom"
    ],

    hospital: [
        "hospital",
        "clinic"
    ]

};


/* ===================================================
   PRODUCT CATEGORIES
=================================================== */

const PRODUCT_CATEGORIES = {

    camera: [
        "camera",
        "cctv",
        "security camera",
        "bulb camera",
        "indoor camera",
        "outdoor camera",
        "ptz camera",
        "wifi camera",
        "ip camera",
        "dual lens",
        "4g camera"
    ],

    lock: [
        "lock",
        "fingerprint",
        "padlock",
        "smart lock",
        "door lock",
        "cabinet lock",
        "drawer lock",
        "biometric"
    ],

    gps: [
        "gps",
        "tracker",
        "vehicle tracker",
        "car tracker",
        "bike tracker"
    ],

    doorbell: [
        "doorbell",
        "video doorbell",
        "smart doorbell"
    ],

    smartwatch: [
        "watch",
        "smart watch",
        "smartwatch"
    ],

    recorder: [
        "voice recorder",
        "audio recorder",
        "recorder"
    ],

    hidden_camera: [
        "hidden camera",
        "spy camera",
        "mini camera",
        "secret camera"
    ],

    dash_camera: [
        "dash camera",
        "dashcam",
        "car camera"
    ],

    smart_bulb: [
        "smart bulb",
        "wifi bulb",
        "led bulb",
        "rgb bulb"
    ],

    smart_light: [
        "light",
        "smart light",
        "solar light",
        "sensor light",
        "night light"
    ],

    smart_switch: [
        "switch",
        "smart switch",
        "wifi switch"
    ],

    smart_sensor: [
        "sensor",
        "motion sensor",
        "door sensor",
        "window sensor",
        "gas sensor",
        "smoke sensor",
        "water leakage"
    ],

    smart_washroom: [
        "automatic tap",
        "sensor tap",
        "touchless tap",
        "smart faucet",
        "bathroom",
        "washroom",
        "toilet seat",
        "wc",
        "water leakage detector"
    ],

    solar: [
        "solar",
        "solar panel",
        "portable solar",
        "solar charger"
    ],

    alarm: [
        "alarm",
        "security alarm",
        "siren"
    ]

};